/**
 * @param {string} url
 */
export function makeLink(url) {
  return /^https?:\/\//i.test(url) ? url : `http://${url}`;
}
